import { useEffect } from "react";
import axios from "../config/axios";
import useAuth from "./useAuth";

import { toast } from "react-toastify";

const useAxios = () => {
  const { token: registered } = useAuth();

  useEffect(() => {
    const requestIntercept = axios.interceptors.request.use(
      (config) => {
        if (!config.headers["Authorization"] && registered) {
          config.headers["Authorization"] = `Bearer ${registered}`;
        }
        return config;
      },
      (error) => Promise.reject(error)
    );

    const responseIntercept = axios.interceptors.response.use(
      (response) => response,

      async (error) => {
        // if (error?.code === "ERR_CANCELED") {
        //   console.log("aborted request");
        // } else {
        if (+error.response.status === 401) {
          toast.error("ليس لديك اشتراك نشط", {
            toastId: "axios",
          });
        } else if (error?.response && !error.response?.data?.Error) {
          toast.error(
            error.response?.data?.response ||
              error?.message ||
              "An error occurred",
            {
              toastId: "axios",
            }
          );
        } else {
          toast.error(error?.message || "An error occurred", {
            toastId: "axios",
          });
        }
        // }
        return Promise.reject(error);
      }
    );

    return () => {
      axios.interceptors.request.eject(requestIntercept);
      axios.interceptors.response.eject(responseIntercept);
    };
  }, [registered]);

  return axios;
};

export default useAxios;
